import React, { useState, useEffect, useCallback } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { id: "nav-home", label: "Home", href: "#home" },
  { id: "nav-about", label: "About", href: "#about" },
  { id: "nav-services", label: "Services", href: "#services" },
  { id: "nav-how", label: "How It Works", href: "#how" },
  { id: "nav-packages", label: "Packages", href: "#packages" },
  { id: "nav-testimonials", label: "Testimonials", href: "#testimonials" },
  { id: "nav-contact", label: "Contact", href: "#contact" },
];

function NavLinks({ onNavigate }) {
  return (
    <>
      {NAV_LINKS.map((l) => (
        <a
          key={l.id}
          href={l.href}
          onClick={onNavigate}
          className="nav-link text-sm font-medium text-neutral-900"
        >
          {l.label}
        </a>
      ))}
    </>
  );
}

function MobileMenu({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="md:hidden bg-[#fbf3e4] border-t border-neutral-200">
      <div className="px-6 py-4 flex flex-col gap-4">
        {NAV_LINKS.map((l) => (
          <a
            key={l.id}
            href={l.href}
            onClick={onClose}
            className="text-neutral-900 text-base font-medium"
          >
            {l.label}
          </a>
        ))}
        <a
          href="#contact"
          onClick={onClose}
          className="bg-neutral-900 text-[#fbf3e4] px-5 py-3 text-sm font-medium text-center"
        >
          Book Now
        </a>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 40);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#fbf3e4]/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-10 py-5">
        <a href="#home" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full border-2 border-neutral-900 flex items-center justify-center">
            <span className="font-display text-lg leading-none">M</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-sm tracking-wider">METE</div>
            <div className="text-[10px] tracking-[0.3em] text-neutral-600">PRIVATE CHEF</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          <NavLinks />
          <a
            href="#contact"
            className="btn-primary bg-neutral-900 text-[#fbf3e4] px-5 py-2.5 text-sm font-medium tracking-wide hover:bg-neutral-700"
          >
            Book Now
          </a>
        </nav>

        <button
          className="md:hidden text-neutral-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <MobileMenu open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
